if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();

      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `bulk-discount-badge-${this.dataset.section}`, `pay-at-checkout-badge-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name="id"]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          // this.renderContents(response);
          handleFloCartBtn();

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

(function initProductMobileThumbnails() {
  const MOBILE_MQ = '(max-width: 1067px)';

  function isMobileView() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function syncThumbnailsFromSlide(gallery, slideEl) {
    if (!gallery || !slideEl || !slideEl.dataset.mediaId) return;
    const strip = gallery.querySelector('.product-thumbnails');
    if (!strip) return;
    const mid = slideEl.dataset.mediaId;
    strip.querySelectorAll('.product-thumbnails__item').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.targetMediaId === mid);
    });
    const activeBtn = strip.querySelector('.product-thumbnails__item.is-active');
    if (activeBtn && typeof activeBtn.scrollIntoView === 'function' && isMobileView()) {
      activeBtn.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }

  function activateThumbnailMedia(gallery, targetMediaId) {
    const slide = gallery.querySelector('.product-images__slide[data-media-id="' + targetMediaId + '"]');
    if (!slide) return;
    gallery.querySelectorAll('.product-images__slide[data-media-id]').forEach((el) => el.classList.remove('is-active'));
    slide.classList.add('is-active');
    slide.parentElement.prepend(slide);
    const slider = gallery.querySelector('product-slider');
    if (slider && typeof slider.scrollTo === 'function') {
      slider.scrollTo({ left: 0, behavior: 'smooth' });
    }
    syncThumbnailsFromSlide(gallery, slide);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-thumbnails__item');
    if (!btn || !isMobileView()) return;
    const strip = btn.closest('.product-thumbnails');
    if (!strip) return;
    e.preventDefault();
    const gallery = strip.closest('[id^="MediaGallery-"]');
    if (!gallery) return;
    const targetId = btn.dataset.targetMediaId;
    if (!targetId) return;
    activateThumbnailMedia(gallery, targetId);
  });

  document.addEventListener('product:variant-change', function (e) {
    const detail = e.detail;
    if (!detail || !detail.sectionId) return;
    const gallery = document.getElementById('MediaGallery-' + detail.sectionId);
    if (!gallery || !gallery.querySelector('.product-thumbnails')) return;
    window.requestAnimationFrame(function () {
      const activeSlide = gallery.querySelector('.product-images__slide.is-active');
      if (activeSlide) syncThumbnailsFromSlide(gallery, activeSlide);
    });
  });

  function bindSliderThumbSync(slider) {
    if (!slider || slider.dataset.thumbSyncBound === 'true') return;
    slider.dataset.thumbSyncBound = 'true';
    slider.addEventListener('slideChanged', function (ev) {
      if (!isMobileView()) return;
      const gallery = slider.closest('[id^="MediaGallery-"]');
      const el = ev.detail && ev.detail.currentElement;
      if (gallery && el) syncThumbnailsFromSlide(gallery, el);
    });
  }

  document.querySelectorAll('product-slider.product-images').forEach(bindSliderThumbSync);

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelectorAll) return;
    ev.target.querySelectorAll('product-slider.product-images').forEach(bindSliderThumbSync);
  });
})();

(function initProductCollectionRecs() {
  var REDUCED_MOTION = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollOpts() {
    return { behavior: REDUCED_MOTION ? 'auto' : 'smooth' };
  }

  function getActiveIndex(track, slides) {
    if (!track || !slides.length) return 0;
    var scrollLeft = track.scrollLeft + 1;
    var active = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].offsetLeft <= scrollLeft) active = i;
    }
    return active;
  }

  function setActiveDot(dots, index) {
    if (!dots || !dots.length) return;
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function bind(root) {
    if (!root || root.dataset.collectionRecsBound === 'true') return;
    var track = root.querySelector('[data-collection-recs-track]');
    var slides = root.querySelectorAll('.product-collection-recs__slide');
    var dots = root.querySelectorAll('[data-collection-recs-dot]');
    if (!track || !slides.length) return;

    root.dataset.collectionRecsBound = 'true';

    var manualPauseFn = null;

    function syncDotsFromScroll() {
      setActiveDot(dots, getActiveIndex(track, slides));
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncDotsFromScroll, 48);
      },
      { passive: true }
    );

    if (dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (manualPauseFn) manualPauseFn();
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          if (isNaN(idx) || !slides[idx]) return;
          var left = slides[idx].offsetLeft;
          track.scrollTo(Object.assign({ left: left }, scrollOpts()));
          window.setTimeout(function () {
            setActiveDot(dots, idx);
          }, REDUCED_MOTION ? 0 : 320);
        });
      });
    }

    syncDotsFromScroll();

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var cur = getActiveIndex(track, slides);
      var next = e.key === 'ArrowRight' ? Math.min(slides.length - 1, cur + 1) : Math.max(0, cur - 1);
      if (next === cur) return;
      e.preventDefault();
      if (manualPauseFn) manualPauseFn();
      track.scrollTo(Object.assign({ left: slides[next].offsetLeft }, scrollOpts()));
      setActiveDot(dots, next);
    });

    var autoplayEnabledAttr = root.getAttribute('data-collection-recs-autoplay') === 'true';
    var intervalSec = parseFloat(root.getAttribute('data-collection-recs-autoplay-interval'), 10);
    if (isNaN(intervalSec)) intervalSec = 5;
    intervalSec = Math.min(15, Math.max(3, intervalSec));

    if (autoplayEnabledAttr && slides.length > 1 && !REDUCED_MOTION) {
      var autoplayTimerId = null;
      var autoScrollGuard = false;
      var pauseHover = false;
      var pauseFocus = false;
      var pauseHidden = typeof document !== 'undefined' && document.hidden;
      var pauseManual = false;
      var manualResumeTimer = null;
      var scrollBoot = false;

      function clearAutoplayTimer() {
        if (autoplayTimerId !== null) {
          window.clearInterval(autoplayTimerId);
          autoplayTimerId = null;
        }
      }

      function shouldAutoplayRun() {
        return (
          !pauseHover &&
          !pauseFocus &&
          !pauseHidden &&
          !pauseManual
        );
      }

      function syncAutoplayTimer() {
        clearAutoplayTimer();
        if (!shouldAutoplayRun()) return;
        var ms = Math.max(2000, Math.round(intervalSec * 1000));
        autoplayTimerId = window.setInterval(advanceAuto, ms);
      }

      function advanceAuto() {
        if (!shouldAutoplayRun()) return;
        var cur = getActiveIndex(track, slides);
        var next = (cur + 1) % slides.length;
        autoScrollGuard = true;
        track.scrollTo(Object.assign({ left: slides[next].offsetLeft }, scrollOpts()));
        setActiveDot(dots, next);
        window.setTimeout(function () {
          autoScrollGuard = false;
        }, REDUCED_MOTION ? 80 : 550);
      }

      function markManualPause() {
        pauseManual = true;
        window.clearTimeout(manualResumeTimer);
        manualResumeTimer = window.setTimeout(function () {
          pauseManual = false;
          syncAutoplayTimer();
        }, 8000);
        syncAutoplayTimer();
      }

      manualPauseFn = markManualPause;

      function onVisibility() {
        if (!root.isConnected) return;
        pauseHidden = document.hidden;
        syncAutoplayTimer();
      }

      function onMouseEnter() {
        pauseHover = true;
        syncAutoplayTimer();
      }

      function onMouseLeave() {
        pauseHover = false;
        syncAutoplayTimer();
      }

      function onFocusIn() {
        pauseFocus = true;
        syncAutoplayTimer();
      }

      function onFocusOut() {
        window.setTimeout(function () {
          if (!root.contains(document.activeElement)) {
            pauseFocus = false;
            syncAutoplayTimer();
          }
        }, 0);
      }

      document.addEventListener('visibilitychange', onVisibility);
      root.addEventListener('mouseenter', onMouseEnter);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('focusin', onFocusIn);
      root.addEventListener('focusout', onFocusOut);

      window.setTimeout(function () {
        scrollBoot = true;
      }, 450);

      track.addEventListener(
        'scroll',
        function () {
          if (!scrollBoot || autoScrollGuard) return;
          markManualPause();
        },
        { passive: true }
      );

      syncAutoplayTimer();
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-collection-recs]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) initAll(ev.target);
  });
})();

(function initProductVariationsSeeAllModal() {
  function dialogSupported() {
    return typeof window.HTMLDialogElement === 'function';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pv-variations-open]');
    if (opener) {
      e.preventDefault();
      if (!dialogSupported()) return;
      var id = opener.getAttribute('aria-controls');
      var dlg = id ? document.getElementById(id) : null;
      if (!dlg || dlg.tagName !== 'DIALOG') return;
      try {
        dlg.showModal();
      } catch (err) {
        /* ignore */
      }
      return;
    }

    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pv-variations-dialog')) {
      e.target.close();
    }
  });
})();

(function initProductReviewSlider() {
  var REDUCED_MOTION = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollOpts() {
    return { behavior: REDUCED_MOTION ? 'auto' : 'smooth' };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(value) {
    var tmp = document.createElement('div');
    tmp.innerHTML = value || '';
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function collectReviewArrays(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    var keys = ['reviews', 'product_reviews', 'featured_reviews', 'items'];
    for (var i = 0; i < keys.length; i++) {
      if (Array.isArray(data[keys[i]])) return data[keys[i]];
    }
    if (data.reviews && Array.isArray(data.reviews.reviews)) return data.reviews.reviews;
    if (data.data && Array.isArray(data.data.reviews)) return data.data.reviews;
    if (data.widget && Array.isArray(data.widget.reviews)) return data.widget.reviews;
    return [];
  }

  function reviewImage(review) {
    var pics = review.pictures || review.photos || [];
    for (var i = 0; i < pics.length; i++) {
      var pic = pics[i];
      if (!pic || pic.hidden) continue;
      if (typeof pic === 'string') return pic;
      var urls = pic.urls || pic;
      var src = urls.compact || urls.small || urls.huge || urls.original || urls.thumb || urls.small_retina;
      if (src) return src;
    }
    var reviewer = review.reviewer || {};
    return reviewer.avatar || reviewer.profile_pic || review.avatar || '';
  }

  function isVerified(review) {
    var value = review.verified_buyer != null ? review.verified_buyer : review.verified;
    if (value === true || value === 'true') return true;
    if (typeof value === 'string' && value.toLowerCase().indexOf('buyer') !== -1) return true;
    return false;
  }

  function firstText() {
    for (var i = 0; i < arguments.length; i++) {
      var value = arguments[i];
      if (value == null) continue;
      var text = stripHtml(value);
      if (text) return text;
    }
    return '';
  }

  function normalizeSpaces(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function collapseForCompare(value) {
    return normalizeSpaces(value).replace(/[^\w]+/g, '').toLowerCase();
  }

  function reviewDescription(review) {
    var title = firstText(review.title, review.review_title);
    var body = firstText(review.body, review.body_html, review.review_body);

    if (!body) {
      var bodyElHtml = '';
      if (typeof review.content === 'string' && review.content.indexOf('jdgm-rev__body') !== -1) {
        var wrap = document.createElement('div');
        wrap.innerHTML = review.content;
        var bodyNode = wrap.querySelector('.jdgm-rev__body');
        if (bodyNode) bodyElHtml = bodyNode.textContent;
      }
      body = firstText(bodyElHtml, review.review);
    }

    body = normalizeSpaces(body);
    title = normalizeSpaces(title);

    if (body && title) {
      var bodyKey = collapseForCompare(body);
      var titleKey = collapseForCompare(title);
      if (bodyKey === titleKey || bodyKey === titleKey + titleKey) return body;
      if (bodyKey.indexOf(titleKey) === 0) {
        var stripped = normalizeSpaces(body.replace(title, '').replace(/^[\s.:,;-]+/, ''));
        if (stripped) return stripped;
      }
    }

    if (body) {
      var mid = Math.floor(body.length / 2);
      if (body.length >= 8) {
        var left = normalizeSpaces(body.slice(0, mid).replace(/[.\s]+$/g, ''));
        var right = normalizeSpaces(body.slice(mid).replace(/^[.\s]+/g, ''));
        if (left && collapseForCompare(left) === collapseForCompare(right)) return left;
      }
    }

    return body || title;
  }

  function normalizeReview(review) {
    if (!review || typeof review !== 'object') {
      return { name: '', text: '', rating: 0, image: '', verified: false };
    }
    var reviewer = review.reviewer || {};
    return {
      name: firstText(reviewer.name, review.name, review.author, review.reviewer_name),
      text: reviewDescription(review),
      rating: Math.max(1, Math.min(5, parseInt(review.rating, 10) || 5)),
      image: reviewImage(review),
      verified: isVerified(review)
    };
  }

  function reviewsFromWidgetHtml(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('.jdgm-rev');
    var reviews = [];
    nodes.forEach(function (node) {
      var nameEl = node.querySelector('.jdgm-rev__author, .jdgm-rev__author-name');
      var bodyEl = node.querySelector('.jdgm-rev__body');
      var titleEl = node.querySelector('.jdgm-rev__title');
      var scoreEl = node.querySelector('[data-score]');
      var imgEl = node.querySelector('.jdgm-rev__author-pic img, .jdgm-rev__pic img, img');
      reviews.push({
        name: nameEl ? nameEl.textContent.trim() : '',
        title: titleEl ? titleEl.textContent.trim() : '',
        body: bodyEl ? bodyEl.textContent.trim() : '',
        rating: scoreEl ? scoreEl.getAttribute('data-score') : 5,
        pictures: imgEl && imgEl.getAttribute('src') ? [imgEl.getAttribute('src')] : [],
        verified_buyer: node.getAttribute('data-verified-buyer') === 'true' || !!node.querySelector('.jdgm-rev__icon-verified, .jdgm-rev__buyer-badge')
      });
    });
    return reviews;
  }

  function starHtml(rating) {
    var html = '<span class="product-review-slider__stars" aria-label="' + rating + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="product-review-slider__star' + (i <= rating ? ' is-filled' : '') + '">★</span>';
    }
    return html + '</span>';
  }

  function verifiedHtml(label) {
    return (
      '<span class="product-review-slider__verified">' +
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
      '<circle cx="6" cy="6" r="6" fill="#1F8A4C"/>' +
      '<path d="M3.4 6.15 5.05 7.8 8.6 4.25" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      escapeHtml(label) +
      '</span>'
    );
  }

  function slideHtml(review, index, total, opts) {
    var initial = (review.name || 'R').charAt(0).toUpperCase();
    var avatar = review.image
      ? '<img src="' + escapeHtml(review.image) + '" alt="' + escapeHtml(review.name) + '" width="64" height="64" loading="lazy">'
      : '<span class="product-review-slider__avatar-fallback" aria-hidden="true">' + escapeHtml(initial) + '</span>';
    var verified = opts.showVerified && review.verified && opts.verifiedLabel ? verifiedHtml(opts.verifiedLabel) : '';
    return (
      '<div class="product-review-slider__slide" role="group" aria-roledescription="slide" aria-label="Review ' + (index + 1) + ' of ' + total + '">' +
        '<article class="product-review-slider__card">' +
          '<div class="product-review-slider__avatar">' + avatar + '</div>' +
          '<div class="product-review-slider__content">' +
            (review.name ? '<p class="product-review-slider__name">' + escapeHtml(review.name) + '</p>' : '') +
            '<div class="product-review-slider__rating-row">' + starHtml(review.rating) + verified + '</div>' +
            (review.text ? '<p class="product-review-slider__text">' + escapeHtml(review.text) + '</p>' : '') +
          '</div>' +
        '</article>' +
      '</div>'
    );
  }

  function renderReviews(root, reviews) {
    var track = root.querySelector('[data-review-slider-track]');
    if (!track) return;
    var opts = {
      showVerified: root.getAttribute('data-show-verified') === 'true',
      verifiedLabel: root.getAttribute('data-verified-label') || 'Verified buyer'
    };
    track.innerHTML = reviews.map(function (review, index) {
      return slideHtml(review, index, reviews.length, opts);
    }).join('');
    root.dataset.reviewSliderBound = 'false';
  }

  function fetchWidgetReviews(root) {
    var shop = root.getAttribute('data-shop-domain');
    var token = root.getAttribute('data-judgeme-token');
    var productId = root.getAttribute('data-product-id');
    var limit = parseInt(root.getAttribute('data-max-reviews'), 10) || 5;
    if (!shop || !token || !productId) return Promise.resolve([]);

    var url =
      'https://api.judge.me/api/v1/widgets/product_review?shop_domain=' +
      encodeURIComponent(shop) +
      '&api_token=' +
      encodeURIComponent(token) +
      '&external_id=' +
      encodeURIComponent(productId) +
      '&per_page=' +
      encodeURIComponent(limit) +
      '&json_request=true';

    return fetch(url)
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject();
      })
      .then(function (json) {
        var reviews = collectReviewArrays(json);
        if (reviews.length) return reviews;
        if (json && json.html) return reviewsFromWidgetHtml(json.html);
        if (json && json.widget) return reviewsFromWidgetHtml(json.widget);
        return [];
      })
      .catch(function () {
        return [];
      });
  }

  function hydrateJudgeMe(root) {
    var source = root.getAttribute('data-review-source') || 'manual';
    if (source === 'manual') return Promise.resolve();

    var minRating = parseInt(root.getAttribute('data-min-rating'), 10) || 1;
    var maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || 5;
    var reviews = [];
    var jsonEl = root.querySelector('[data-review-slider-judgeme]');
    if (jsonEl) {
      try {
        reviews = collectReviewArrays(JSON.parse(jsonEl.textContent));
      } catch (err) {
        reviews = [];
      }
    }

    if (!reviews.length) {
      var htmlEl = root.querySelector('[data-review-slider-widget-html]');
      if (htmlEl) reviews = reviewsFromWidgetHtml(htmlEl.innerHTML);
    }

    function apply(list) {
      var normalized = list
        .map(normalizeReview)
        .filter(function (review) {
          return review.text && review.rating >= minRating;
        })
        .slice(0, maxReviews);

      if (!normalized.length) {
        var existing = root.querySelectorAll('.product-review-slider__slide').length;
        if (!existing && source === 'judgeme') root.classList.add('is-empty');
        root.classList.remove('is-loading');
        return;
      }

      renderReviews(root, normalized);
      root.classList.remove('is-loading', 'is-empty');
    }

    if (reviews.length) {
      apply(reviews);
      return Promise.resolve();
    }

    root.classList.add('is-loading');
    return fetchWidgetReviews(root).then(apply);
  }

  function getActiveIndex(track, slides) {
    if (!track || !slides.length) return 0;
    var scrollLeft = track.scrollLeft + 1;
    var active = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].offsetLeft <= scrollLeft) active = i;
    }
    return active;
  }

  function setActiveDot(dots, index) {
    if (!dots || !dots.length) return;
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function bind(root) {
    if (!root || root.dataset.reviewSliderBound === 'true') return;
    var track = root.querySelector('[data-review-slider-track]');
    var slides = root.querySelectorAll('.product-review-slider__slide');
    var dots = root.querySelectorAll('[data-review-slider-dot]');
    if (!track || !slides.length) return;

    root.dataset.reviewSliderBound = 'true';

    var manualPauseFn = null;

    function goTo(index) {
      if (!slides[index]) return;
      track.scrollTo(Object.assign({ left: slides[index].offsetLeft }, scrollOpts()));
      window.setTimeout(function () {
        setActiveDot(dots, index);
      }, REDUCED_MOTION ? 0 : 320);
    }

    function syncDotsFromScroll() {
      setActiveDot(dots, getActiveIndex(track, slides));
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncDotsFromScroll, 48);
      },
      { passive: true }
    );

    if (dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (manualPauseFn) manualPauseFn();
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          if (isNaN(idx)) return;
          goTo(idx);
        });
      });
    }

    syncDotsFromScroll();

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var cur = getActiveIndex(track, slides);
      var next = e.key === 'ArrowRight' ? Math.min(slides.length - 1, cur + 1) : Math.max(0, cur - 1);
      if (next === cur) return;
      e.preventDefault();
      if (manualPauseFn) manualPauseFn();
      track.scrollTo(Object.assign({ left: slides[next].offsetLeft }, scrollOpts()));
      setActiveDot(dots, next);
    });

    var autoplayEnabledAttr = root.getAttribute('data-review-slider-autoplay') === 'true';
    var intervalSec = parseFloat(root.getAttribute('data-review-slider-autoplay-interval'), 10);
    if (isNaN(intervalSec)) intervalSec = 5;
    intervalSec = Math.min(15, Math.max(3, intervalSec));

    if (autoplayEnabledAttr && slides.length > 1 && !REDUCED_MOTION) {
      var autoplayTimerId = null;
      var autoScrollGuard = false;
      var pauseHover = false;
      var pauseFocus = false;
      var pauseHidden = typeof document !== 'undefined' && document.hidden;
      var pauseManual = false;
      var manualResumeTimer = null;
      var scrollBoot = false;

      function clearAutoplayTimer() {
        if (autoplayTimerId !== null) {
          window.clearInterval(autoplayTimerId);
          autoplayTimerId = null;
        }
      }

      function shouldAutoplayRun() {
        return !pauseHover && !pauseFocus && !pauseHidden && !pauseManual;
      }

      function syncAutoplayTimer() {
        clearAutoplayTimer();
        if (!shouldAutoplayRun()) return;
        autoplayTimerId = window.setInterval(advanceAuto, Math.max(2000, Math.round(intervalSec * 1000)));
      }

      function advanceAuto() {
        if (!shouldAutoplayRun()) return;
        var next = (getActiveIndex(track, slides) + 1) % slides.length;
        autoScrollGuard = true;
        track.scrollTo(Object.assign({ left: slides[next].offsetLeft }, scrollOpts()));
        setActiveDot(dots, next);
        window.setTimeout(function () {
          autoScrollGuard = false;
        }, REDUCED_MOTION ? 80 : 550);
      }

      function markManualPause() {
        pauseManual = true;
        window.clearTimeout(manualResumeTimer);
        manualResumeTimer = window.setTimeout(function () {
          pauseManual = false;
          syncAutoplayTimer();
        }, 8000);
        syncAutoplayTimer();
      }

      manualPauseFn = markManualPause;

      document.addEventListener('visibilitychange', function () {
        if (!root.isConnected) return;
        pauseHidden = document.hidden;
        syncAutoplayTimer();
      });
      root.addEventListener('mouseenter', function () {
        pauseHover = true;
        syncAutoplayTimer();
      });
      root.addEventListener('mouseleave', function () {
        pauseHover = false;
        syncAutoplayTimer();
      });
      root.addEventListener('focusin', function () {
        pauseFocus = true;
        syncAutoplayTimer();
      });
      root.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!root.contains(document.activeElement)) {
            pauseFocus = false;
            syncAutoplayTimer();
          }
        }, 0);
      });

      window.setTimeout(function () {
        scrollBoot = true;
      }, 450);

      track.addEventListener(
        'scroll',
        function () {
          if (!scrollBoot || autoScrollGuard) return;
          markManualPause();
        },
        { passive: true }
      );

      syncAutoplayTimer();
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-review-slider]').forEach(function (root) {
      hydrateJudgeMe(root).then(function () {
        if (!root.classList.contains('is-empty')) bind(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) initAll(ev.target);
  });
})();